import React from 'react';
import {Link} from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import ReactPageScroller from 'react-page-scroller';
import Footer from '../sections/footer';
// import accessibility from '../images/home/accessibility.png';
import appdev from '../images/home/app-development.png';
import digitalmarketing from '../images/home/digital-marketing.png';
import ecommerce from '../images/home/ecommerce.png';
import uiux from '../images/home/ui-ux.png';
import webdev from '../images/home/web-development.png';
import PatternCircle from '../svgs/pattern-circle';
import Arrow from '../svgs/single-arrow';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Typewriter from '../components/typewriter';

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`
const trans2 = (x, y) => `translate3d(${x / 8 + 35}px,${y / 8 - 230}px,0)`
const trans3 = (x, y) => `translate3d(${x / 6 - 250}px,${y / 6 - 200}px,0)`
// const trans4 = (x, y) => `translate3d(${x / 3.5}px,${y / 3.5}px,0)`

function Home() {    
    
    //add a class to body
    const body = document.body;
    body.classList = 'template-home'; 

    const services = require('../jsons/navigations/services-list.json'); 
       
    const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }));

    const scrollerTexts = ["WE CREATE CURIOSITY", "WHAT WE REALLY DO", "WHAT WE ARE GOOD AT"]
    const totalSections = 7;
    
    // const ra = scrollProgress.getElementsByClassName('.dynamic');
    const handlePageChange = (number) => {
        var scrollProgress = document.querySelector('.scrollProgress .dynamic');
        var currentScrollText = scrollerTexts[number];
        var sideFloatingText = document.getElementsByClassName('sideFloatingHeading');
        if(currentScrollText){
            sideFloatingText[0].innerText = currentScrollText;
        }
        scrollProgress.style.height = (100/totalSections) * number + '%';
        if(number === totalSections){
            body.classList.add('footer-in-view');
        }else{
            body.classList.remove('footer-in-view'); 
        }
    }
    return (        
        <div>
            <ReactPageScroller  
                pageOnChange={handlePageChange}          
            >
                <section className="textWithImageSection heroSection orangeBg" onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })} >
                    <div className="innerSection">
                        <div className="leftBox">   
                            <div className="bubbles mobile-only">
                            <span className="big" />
                            <span className="small" />
                            <span className="small small-2" />
                            </div>                          
                            <Typewriter
                                textArr={["we design-we develop-we innovate-we inspire"]}
                                isSubtext="false"
                            />                              
                        </div>
                        <div className="rightBox desktop-only">
                            <animated.span className="big" style={{ transform: props.xy.interpolate(trans1) }} />
                            <animated.span className="small" style={{ transform: props.xy.interpolate(trans3) }} />
                            <animated.span className="small small-2" style={{ transform: props.xy.interpolate(trans2) }} />
                            <PatternCircle />
                        </div>
                    </div>
                </section>
                <section className="serviceSection lightOrangeBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <Typewriter
                                textArr={["globally top-rated shopify-experts|WE ARE DIGITAL EXPERTS.", 
                                        "globally top-rated magento-experts| WE ARE MAGENTO EXPERTS"]}
                                isSubtext="true"
                            />
                        </div>
                        <div className="rightBox">
                            <h4 className="heading1">SERVICES</h4>
                            <ul className="listing">
                                {services.map((service, index) =>
                                    <li key={index}>
                                            <Link to={service.url}>
                                            <strong>{service.key}</strong>
                                            <span className="slash">/</span>
                                            {service.title}
                                        </Link>
                                    </li>
                                )}                            
                            </ul>
                            {/* <p>We are based in New York & India.<br/> We specialise in strategy, design, & development across all platforms.</p> */}
                        </div>
                    </div>
                </section>
                <section className="textWithImageSection peachBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">eCommerce</h3>
                            <ul className="listing dash">
                                <li><Link to="/shopify">Shopify<Arrow /></Link></li>                                
                                <li><Link to="/magento">Magento<Arrow /></Link></li>
                                <li><Link to="/shopify-plus">Shopify+<Arrow /></Link></li>                                
                                <li><Link to="/services/ecommerce">Bigcommerce<Arrow /></Link></li>
                                <li><Link to="/services/ecommerce">Woocommerce<Arrow /></Link></li>
                                <li><Link to="/services/ecommerce">Salesforce Commerce Cloud<Arrow /></Link></li>
                                <li><Link to="/services/ecommerce">Prestashop<Arrow /></Link></li>
                                <li><Link to="/services/ecommerce">Custom design<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/ecommerce"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">eCommerce</h3>
                            <LazyLoadImage
                                alt="eCommerce"
                                className="bounce-up-down"
                                effect="blur"
                                src={ecommerce} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>
                <section className="textWithImageSection cornBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">web<br/>development</h3>
                            <ul className="listing dash">
                                <li><Link to="/services/web-development">Custom Web App<Arrow /></Link></li>
                                <li><Link to="/services/web-development">Custom Plugin / Integration<Arrow /></Link></li>
                                <li><Link to="/services/web-development">Bots/ AI<Arrow /></Link></li>
                                <li><Link to="/services/web-development">CRM<Arrow /></Link></li>
                                <li><Link to="/services/web-development">ERP<Arrow /></Link></li>
                                <li><Link to="/services/web-development">HIPAA Compliant Application<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/web-development"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">web<br/>development</h3>
                            <LazyLoadImage
                                alt="Web Development"
                                className="bounce-up-down"
                                effect="blur"
                                src={webdev} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>
                <section className="textWithImageSection greenBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">apps</h3>
                            <ul className="listing dash">
                                <li><Link to="/services/apps">Native Mobile Apps - Mobile/Tablet<Arrow /></Link></li>
                                <li><Link to="/services/apps">Smart Device Application<Arrow /></Link></li>
                                <li><Link to="/services/apps">React Native Apps<Arrow /></Link></li>
                                <li><Link to="/services/apps">Hybrid Apps<Arrow /></Link></li>
                                <li><Link to="/services/apps">HIPAA Compliant Application<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/apps"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">apps</h3>
                            <LazyLoadImage
                                alt="Apps"
                                className="bounce-up-down"
                                effect="blur"
                                src={appdev} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>
                <section className="textWithImageSection lightGreenBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">growth<br />marketing</h3>
                            <ul className="listing dash">
                                <li><Link to="/services/growth-marketing">SEO<Arrow /></Link></li>
                                <li><Link to="/services/growth-marketing">Social Media Management<Arrow /></Link></li>
                                <li><Link to="/services/growth-marketing">Pay Per Click<Arrow /></Link></li>
                                <li><Link to="/services/growth-marketing">Content Creation<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/growth-marketing"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">growth<br />marketing</h3>
                            <LazyLoadImage
                                alt="Growth Marketing"
                                className="bounce-up-down"
                                effect="blur"
                                src={digitalmarketing} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>
                <section className="textWithImageSection cyanBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">ui / ux design</h3>
                            <ul className="listing dash">
                                <li><Link to="/services/ui-ux-design">Wireframing<Arrow /></Link></li>
                                <li><Link to="/services/ui-ux-design">Branding<Arrow /></Link></li>
                                <li><Link to="/services/ui-ux-design">Motion Design<Arrow /></Link></li>
                                <li><Link to="/services/ui-ux-design">User Experience<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/ui-ux-design"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">ui / ux design</h3>
                            <LazyLoadImage
                                alt="UI/UX Design"
                                className="bounce-up-down"
                                effect="blur"
                                src={uiux} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>
                {/*<section className="textWithImageSection blueBg">
                    <div className="innerSection">
                        <div className="leftBox">
                            <h3 className="desktop-only">ada compliance</h3>
                            <ul className="listing dash">
                                <li><Link to="/services/ada-compliance">ADA Compliance Audit<Arrow /></Link></li>
                                <li><Link to="/services/ada-compliance">Accessibility Consulting<Arrow /></Link></li>
                                <li><Link to="/services/ada-compliance">Accessibility Remediation<Arrow /></Link></li>
                                <li><Link to="/services/ada-compliance">Accessibility Training<Arrow /></Link></li>
                                <li><Link to="/services/ada-compliance">PDF Accessibility<Arrow /></Link></li>
                                <li><Link to="/services/ada-compliance">VPAT Creation<Arrow /></Link></li>
                            </ul>
                            <Link 
                                to="/services/ada-compliance"
                                className="btn pill"
                                >
                                Check Our Portfolio
                            </Link>
                        </div>
                        <div className="rightBox">
                            <h3 className="mobile-only">ada compliance</h3>
                            <LazyLoadImage
                                alt="Accessibility"
                                className="bounce-up-down"
                                effect="blur"
                                src={accessibility} // use normal <img> attributes as props
                                />
                        </div>
                    </div>
                </section>*/}
                <Footer/>
            </ReactPageScroller>
        </div>
    );
}   

export default Home;